module.exports = __webpack_public_path__ + "img/Compact-Repairing.04aede69.jpg";